import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import config from '@epi-config';
import { IReportType } from '@epi-models/pages/DownloadReports';
import { DownloadReportType } from '@epi-constants/downloadReports';

const sortReportTypes = (reports: IReportType[]) => {
  const sortOrder = {
    [DownloadReportType.PayrollReport]: 1,
    [DownloadReportType.IncomeReport]: 2,
    [DownloadReportType.OtherReport]: 3
  };

  return reports.sort((a, b) => sortOrder[a] - sortOrder[b]);
};

export const getReportTypes = async (): Promise<IReportType[]> =>
  get<IReportType[]>(`${config.apiHost}/api/reports/available-reports`);

export const downloadReportsApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getReportTypes: build.query<IReportType[] | [], void>({
      async queryFn(_arg, api) {
        try {
          const data = await getReportTypes();

          const sortedTypes = sortReportTypes(data);

          return { data: sortedTypes ?? [] };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 1800
    })
  })
});

export const { useGetReportTypesQuery } = downloadReportsApi;
